// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { getFirestore } from "@firebase/firestore";

// const firebaseConfig = {
//   apiKey: "AIzaSyBXGkBzRsY7kpT5E3Hge0BYUs3WolzQHGA",
//   authDomain: "anushthan-firebase.firebaseapp.com",
//   databaseURL: "https://anushthan-firebase-default-rtdb.asia-southeast1.firebasedatabase.app",
//   projectId: "anushthan-firebase",
//   storageBucket: "anushthan-firebase.firebasestorage.app",
//   messagingSenderId: "457458239140",
//   appId: "1:457458239140:web:473a1b9a16169d3fd34831"
// };

const firebaseConfig = {
  apiKey: "AIzaSyBeFAacSNvNMDmfrQjyoUewR13w2ZHwcxU",
  authDomain: "anushthan-website.firebaseapp.com",
  projectId: "anushthan-website",
  storageBucket: "anushthan-website.firebasestorage.app",
  messagingSenderId: "37630358817",
  appId: "1:37630358817:web:8bf61462980cfadea5fa60"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const firestore = getFirestore(app);